import { Toast } from '../../../components/Common/Toast';
import { HTTPStatusEnum } from '../../../interfaces/log.interface';
import { callAPI } from '../../../services/api.service';

export const cancelUserSubscription = async (email: string): Promise<{ message: string; status: number } | null> => {
  try {
    const response = await callAPI('user/cancel-subscription', { email });
    Toast(
      response?.message || 'Unexpected Error Occurred',
      response?.status !== HTTPStatusEnum.OK
    );
    return response;
  } catch (error) {
    Toast('Unexpected Error Occurred', true);
    return null;
  }
};